module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_a-function.js
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11